import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";
import Modal from "../../commonComponents/util/Modal";
import AutocompleteMultiInput from "../../commonComponents/util/AutocompleteMultiInput";
import { getFunds } from "../../../redux/actions/FundsActions";

class PledgeReportModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFunds: [],
      includeClosed: false,
      submitAttempted: false,
      downloading: false
    };
  }

  componentDidMount() {
    if (!this.props.fundsLoaded && !this.props.fundsLoading) {
      this.props.actions.getFunds();
    }
  }

  close = () => {
    this.setState({
      selectedFunds: [],
      includeClosed: false,
      submitAttempted: false,
      downloading: false
    });
    this.props.close();
  };

  onToggleIncludeClosed = (e) => {
    this.setState({ includeClosed: e.target.checked });
  };

  onUpdateFunds = (name, selections) => {
    this.setState({ selectedFunds: selections || [] });
  };

  onDownload = async () => {
    const { selectedFunds } = this.state;
    this.setState({ submitAttempted: true });

    try {
      this.setState({ downloading: true });
      const params = {
        fundIds: selectedFunds,
        includeClosed: this.state.includeClosed
      };

      // Delegate to parent handler (to be wired to API)
      await Promise.resolve(this.props.onDownload && this.props.onDownload(params));

      this.setState({ downloading: false }, this.close);
    } catch (e) {
      const isNoData = e && e.message === "noData";
      const errorMessage = isNoData
        ? "No data found for the selected criteria."
        : "Something went wrong. Please try again.";
      toastr.error("Report download failed", errorMessage);
      this.setState({ downloading: false }, this.close);
    }
  };

  render() {
    const { show, fundsOptions } = this.props;
    const { selectedFunds, includeClosed, downloading } = this.state;

    const options = (fundsOptions || []).map(f => ({ key: f.key, value: f.value }));

    return (
      <Modal modalShowing={show}>
        <div className="modal-container">
          <div className="modal new-fund-modal large-modal pledge-report-modal">
            <div className="bordered-modal-header">
              <h4 className="modal-page-header">Pledge Report</h4>
              <i className="icon ion-ios-close-empty" onClick={this.close} />
            </div>

            <div className="modal-section">
              <div className="modal-row modal-row-full-width">
                <div>
                  <div className="flex">
                    <label className="input-label">
                      Funds
                    </label>
                  </div>
                  <AutocompleteMultiInput
                    name="fundIds"
                    options={options}
                    selection={selectedFunds}
                    placeholder="Select funds"
                    disabled={!options.length}
                    update={this.onUpdateFunds}
                  />
                </div>
              </div>

              <div className="modal-row modal-row-full-width pledge-report-row">
                <div>
                  <div className="custom-check-container">
                    <input
                      type="checkbox"
                      id="include-closed-pledges"
                      className="custom-check"
                      name="includeClosed"
                      checked={includeClosed}
                      onChange={this.onToggleIncludeClosed}
                    />
                    <label htmlFor="include-closed-pledges" className="secondary-text">
                      Include Closed Pledges
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-btns text-right">
              <button className="btn btn-accent" onClick={this.close}>Cancel</button>
              <button className="btn btn-primary" onClick={this.onDownload} disabled={downloading}>
                {downloading ? "Downloading Report" : "Download Report"}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    fundsOptions: state.funds.fundsByDept.all,
    fundsLoaded: (state.funds.fundsByDept.all || []).length > 0,
    fundsLoading: state.funds.fundsByDept.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ getFunds }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PledgeReportModal);



// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccounts/PledgeReportModal.jsx